import ProgressRing from '@jobseeker/lotus/components/ProgressRing';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

type AvatarWithProgress = {
  profilePicture: string;
  percentage: number;
  isOnline?: boolean;
  top?: number;
};
const AvatarWithProgress = ({
  profilePicture,
  percentage,
  isOnline = false,
  top = 4,
}: AvatarWithProgress) => {
  return (
    <Box
      sx={{
        width: 48,
        cursor: 'pointer',
        height: 48,
        position: 'relative',
        borderRadius: '50%',
        float: 'right',
        marginTop: 1,
        marginLeft: 1,
      }}
    >
      {isOnline && (
        <Box
          component={'span'}
          sx={{
            width: 13,
            height: 13,
            border: 'solid 3px #ffffff',
            backgroundColor: '#F64B4B',
            borderRadius: '50%',
            display: 'inline-block',
            marginRight: '14px',
            marginLeft: '30px',
            marginBottom: '-6px',
            marginTop: `${top}px`,
            zIndex: 2,
            position: 'absolute',
          }}
        />
      )}
      <Image
        src={
          profilePicture ||
          'https://job-static.hirist.com/V8/static/media/profile-pic.7ce75fb6.svg'
        }
        alt={'user_profile'}
        data-testid="header-profile-avatar-image"
        width={40}
        height={40}
        style={{
          position: 'absolute',
          borderRadius: '50%',
          zIndex: 1,
          border: '4px solid #ffffff',
          left: 1,
          top: 1,
        }}
      />
      <ProgressRing progress={percentage ?? 0} radius={27} stroke={2.5} />
    </Box>
  );
};

export default AvatarWithProgress;
